<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <div class="d-flex align-center mb-2">
      <a-form-model2
        v-model="data"
        class="mt-1"
        :model="model"
        :modelForm="modelForm"
        :values="data"
        :errors="errors"
        :config="{ dense: true, hideDetails: 'true', readonly }"
        @validate="validate($event)"
      />
    </div>
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />
    <portal to="v-wizard-action">
      <v-btn v-if="!readonly" @click="onUndo" class="mr-2">Назад</v-btn>
      <v-btn @click="onNext">Далее</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";
import { readonly } from "vue";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      services: [],
      services_: [],
      model: [],
      data: {},
      loaded: true,
    };
  },
  computed: {
    readonly() {
      return !!this.wizard?.estimate?.id || !!this.wizard?.contract?.template_id;
    },
    m() {
      return this.mw; //.wizardContract;
    },
    config() {
      return this.mw?.config || {}; //.wizardContract;
    },
  },
  created() {
    this.init();
  },
  watch: {
    services(v) {},
  },
  methods: {
    waitForEvent(eventName, payload) {
      return new Promise(resolve => {
        this.$emit(eventName, payload, resolve);
      });
    },
    init() {
      this.loaded = !true;
      this.services_ = [...(this.wizard?.services?.services || [])];
      this.services = this.services_ || [];
      this.calcModel();
      this.applyData({ services: this.services });
      this.loaded = true;
    },
    updateData() {},

    calcModel(t) {
      const config = this.config;
      let model = this.calcModelConfig(config);

      this.fillFormFromModel(model);
      this.model = model;
      return model;
    },
    async onUndo() {
      await this.waitForEvent("save", {});
      this.$emit("next", -1);
    },
    async onNext() {
      if (await this.validateAll(this.data)) {
      } else {
        return;
      }
      if (this.isChanged) {
        const result = await this.waitForEvent("save", { services: this.data.services });
        this.isChanged = false;
        this.$emit("next");
      } else {
        this.$emit("next");
      }
    },
  },
};
</script>
